module.exports = __webpack_public_path__ + "static/media/icon_gcp-sql-server.0269bf08.svg";